import ApiInstance from './instance'
import { IBatchTemplate, ITemplate, ITemplateFilterDTO, URL_MAPPING } from '@zunta/configurations'

const { template: templateUrls } = URL_MAPPING

export default class TemplateApi {
  instance: ApiInstance

  constructor (instance: ApiInstance) {
    this.instance = instance
  }

  addTemplate (data: Partial<ITemplate>): Promise<ITemplate> {
    return this.instance.doPost(`${templateUrls.prefix}${templateUrls.addTemplate.path}`, { template: data })
  }

  updateTemplate (templateId: string | number, data: Partial<ITemplate>): Promise<ITemplate> {
    return this.instance.doPut(`${templateUrls.prefix}${templateUrls.updateTemplate.path}/${templateId}`, { template: data })
  }

  getTemplateById (templateId: string | number): Promise<ITemplate> {
    return this.instance.doGet(`${templateUrls.prefix}${templateUrls.getTemplateById.path}/${templateId}`)
  }

  getFilteredTemplates (filters: ITemplateFilterDTO): Promise<{ total: number, templates: ITemplate[] }> {
    return this.instance.doGet(`${templateUrls.prefix}${templateUrls.getFilteredTemplates.path}`, filters)
  }

  deleteTemplate (templateId: number | string): Promise<'OK'> {
    return this.instance.doDelete(`${templateUrls.prefix}${templateUrls.deleteTemplate.path}/${templateId}`)
  }

  getBatchSettingsTemplates (settingsId: number | string): Promise<IBatchTemplate[]> {
    return this.instance.doGet(`${templateUrls.prefix}/settingsTemplates/${settingsId}`)
  }

  updateBatchSettingTemplate (batchTemplate: Partial<IBatchTemplate>): Promise<IBatchTemplate> {
    return this.instance.doPost(`${templateUrls.prefix}/settingsTemplates`, { batchTemplate })
  }

  deleteBatchSettingsTemplates (batchTemplateId: number | string): Promise<'OK'> {
    return this.instance.doDelete(`${templateUrls.prefix}/settingsTemplates/${batchTemplateId}`)
  }

  uploadPDFLetter (file: any) {
    const form = new FormData()
    form.append('file', file)
    return this.instance.doPost('/templates/uploadPDFTemplateLetter', form, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    })
  }
}
